var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#999999;}\n\t.st2{clip-path:url(#SVGID_00000109736303127049173360000007844606011031606431_);}\n\t.st3{clip-path:url(#SVGID_00000062914916147553640260000008272686713955724688_);}\n\t.st4{fill:none;stroke:#999999;stroke-width:2.2321;}\n\t.st5{clip-path:url(#SVGID_00000070081236979604127700000015100889382734893201_);}\n\t.st6{fill:#FF6CE2;}\n\t.st7{fill:#7B3566;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_white_24dp",
    transform: "translate(-5066 7318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    className: "st0",
    d: "M5066-7318h50v50h-50V-7318z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    className: "st1",
    d: "M5108.14-7314.43h-34.29c-2.36,0.01-4.26,1.93-4.26,4.29l-0.02,38.57l8.57-8.57h30 c2.36-0.01,4.28-1.92,4.29-4.29v-25.71C5112.42-7312.51,5110.51-7314.42,5108.14-7314.43z M5078.14-7299.43h25.71v4.29h-25.71 V-7299.43z M5095.29-7288.71h-17.14v-4.29h17.14V-7288.71z M5103.86-7301.57h-25.71v-4.29h25.71V-7301.57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons15);
export default __webpack_public_path__ + "static/media/Icons-15.76a073588bf0b039c25890e48793e285.svg";
export { ForwardRef as ReactComponent };